module.exports = __webpack_public_path__ + "static/media/header-bg.df0d7503.png";